<template>
  <a href="https://www.strava.com/clubs/fitsnack" target="_blank" class="no-underline!">
    <button
      type="button"
      class="w-[259.26px] button solid-button transition-animation elevation-animation"
    >
      Join the club
      <svg
        class="w-4 h-4"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 10"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M1 5h12m0 0L9 1m4 4L9 9"
        />
      </svg>
    </button>
  </a>
</template>

<script setup lang="ts"></script>

<style scoped></style>
